import { Button } from "@/components/ui/button";
import { WhatsappLogo } from "@phosphor-icons/react";

/**
 * Click-to-send WhatsApp button.
 * Opens wa.me with a pre-filled message. The sender picks the recipient(s) in WhatsApp.
 * This is legal and free — no Business API needed.
 *
 * Props:
 *  - message: string (required) — pre-filled text
 *  - phone: string (optional) — normalize to MX/+52 if short; if omitted opens the generic share picker
 *  - label: string (optional) — button label (default "WhatsApp")
 *  - size, variant, className: forwarded to Button
 *  - testId: string
 */
export default function WhatsAppShareButton({ message, phone, label = "WhatsApp", size = "sm", variant = "outline", className = "", testId }) {
  const buildUrl = () => {
    const text = encodeURIComponent(message || "");
    if (phone) {
      const clean = String(phone).replace(/[^\d]/g, "");
      const normalized = clean.length === 10 ? `52${clean}` : clean; // MX default
      return `https://wa.me/${normalized}?text=${text}`;
    }
    return `https://wa.me/?text=${text}`;
  };
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(buildUrl(), "_blank", "noopener,noreferrer");
  };
  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleClick}
      className={`border-green-500/30 text-green-400 hover:bg-green-500/10 text-xs uppercase font-bold ${className}`}
      data-testid={testId || "whatsapp-share-btn"}
    >
      <WhatsappLogo size={14} className="mr-1" /> {label}
    </Button>
  );
}
